import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import Overview from "@/components/tabs/Overview"
import FAQ from "@/components/tabs/FAQ"
import Reviews from "@/components/tabs/Reviews"
import { useTranslation } from "react-i18next"
import { track, EVENTS } from "@/lib/mixpanel"

interface ProductTabsProps {
  onPurchase: (planId: string) => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onTabChange: (tab: string) => void;
  isFloatingCountdownVisible: boolean;
}

// TODO: isFloatingCountdownVisible is DEPRECATED
const ProductTabs = ({ onPurchase, activeTab, setActiveTab, onTabChange, isFloatingCountdownVisible }: ProductTabsProps) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={activeTab}
      className="w-screen md:w-full z-50"
      onValueChange={(value) => {
        console.log('onTabChange', value);
        setActiveTab(value);
        onTabChange(value);
        track(EVENTS.CHANGE_TAB, {
          tabName: value,
          tabLabel: t(`productTabs.${value}`)
        });
      }}>
      <div className={`sticky ${isFloatingCountdownVisible ? 'top-0 md:top-0' : 'top-0'} bg-slate-50 z-50 px-3`}>
        <TabsList className="w-full px-4" variant="line">
          <TabsTrigger value="overview" variant="line" className="px-6 text-sm md:text-base">{t('productTabs.overview')}</TabsTrigger>
          <TabsTrigger value="reviews" variant="line" className="px-6 text-sm md:text-base">{t('productTabs.reviews')}</TabsTrigger>
          <TabsTrigger value="faq" variant="line" className="px-6 text-sm md:text-base">{t('productTabs.faq')}</TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="overview" className="mt-6 scroll-mt-20" id="overview">
        <Overview onPurchase={onPurchase} />
      </TabsContent>

      <TabsContent value="reviews" className="mt-6 scroll-mt-20" id="reviews">
        <Reviews onPurchase={onPurchase} />
      </TabsContent>

      <TabsContent value="faq" className="mt-6 scroll-mt-20" id="faq">
        <FAQ onPurchase={onPurchase} />
      </TabsContent>
    </Tabs>
  )
}

export default ProductTabs